import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import UserNavigation from '../userNavigation/userNavigation';

import './userIcon.scss';

interface UserIconIntf {
  img?: any;
  id: string;
}

const UserIcon: React.FC<UserIconIntf> = ({ id }) => {
  const [userName, setUserName] = useState<string>('');
  const [nav, setNav] = useState<boolean>(false);

  const getInitials = (name: string) => {
    if (name.includes(' ')) {
      return name
        .split(' ')
        .map((word) => {
          if (!word[0].startsWith('(')) {
            return word[0];
          }
        })
        .join('');
    }
    return name[0];
  };

  const user: string | null | undefined = useSelector((state: RootState) => state.user.name);

  useEffect(() => {
    user && setUserName(getInitials(user.trim()));
  }, [user]);

  const clickHandler = (e: any) => {
    e.stopPropagation();
    setNav(!nav);
  };

  return (
    <div id={id} className={'userIconWrapper'}>
      <button id={id} className={'userButton'} onClick={clickHandler}>
        <span id={id} className="userIcon initials">
          {userName.toUpperCase()}
        </span>
      </button>
      {nav && <UserNavigation setNav={setNav} id={id} />}
    </div>
  );
};

export default UserIcon;
